import {
  USER_IMAGE_UPDATE_REQUEST,
  USER_IMAGE_UPDATE_FAILURE,
  PROFILE_REQUEST,
  PROFILE_SUCCESS,
  PROFILE_FAILURE,
  ERASE_USER_STATE,
  PROFILE_UPDATE_FAILURE,
  PROFILE_UPDATE_REQUEST,
} from "../actions/userProfileActions";

const initialState = {
  userProfile: {},
  isProfileFetching: false,
  profileFetchError: false,
  profileListener: {},
  isUpdating: false,
  userImgUpdated: false,
  updateError: "",
  profileUpdated: false,
  profileUpdateError: "",
};

const userProfileReducer = (state = initialState, action) => {
  switch (action.type) {
    case USER_IMAGE_UPDATE_REQUEST:
      return {
        ...state,
        isUpdating: true,
        updateError: false,
      };
    case USER_IMAGE_UPDATE_FAILURE:
      return {
        ...state,
        isUpdating: false,
        userImgUpdated: false,
        updateError: action.error,
      };
    case PROFILE_UPDATE_REQUEST:
      return {
        ...state,
        isUpdating: true,
        profileUpdateError: false,
      };
    case PROFILE_UPDATE_FAILURE:
      return {
        ...state,
        isUpdating: false,
        profileUpdated: false,
        profileUpdateError: action.error,
      };
    case PROFILE_REQUEST:
      return {
        ...state,
        isProfileFetching: true,
        profileFetchError: false,
      };
    case PROFILE_SUCCESS:
      return {
        ...state,
        isProfileFetching: false,
        profileFetchError: false,
        userProfile: action.userProfile,
      };
    case PROFILE_FAILURE:
      return {
        ...state,
        isProfileFetching: false,
        profileFetchError: true,
        error: action.error,
      };

    case ERASE_USER_STATE:
      return initialState;

    default:
      return state;
  }
};
export default userProfileReducer;
